import app from './app';
// Auth
import authModule from './auth';
// Configuração
import configuracaoModule from './configuracao';
// Frota
import frotaModule from './frota';

export default {
  modules: {
    app,
    ...authModule,
    ...configuracaoModule,
    ...frotaModule,
  },
  actions: {},
};
